// extracted by mini-css-extract-plugin
export default {"container":"container__VfgqP","search-input":"search-input__yaKtx","btn":"btn__7Fy3V","link":"link__wWKAx"};